/* eslint-disable no-console */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import symbolConfig from "configs/symbols";
import APIHelper from "@giscon/utils.api-helper-esri";
import GpsFixedIcon from "@mui/icons-material/GpsFixed";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";

const symbols = symbolConfig(3);

const showValue = (layer, geometry, symbol) => {
  const graphic = APIHelper.createGraphic(geometry, symbol);
  APIHelper.addGraphicToLayer(graphic, layer);
};

const GeometryPicker = ({
  symbol = "default",
  disabled = false,
  value,
  onChange = (geo) => {
    /* do sth with value */ console.warn(
    "Value changed to ",
    geo,
    "you should overwrite this function!"
  );
  },
  type = "point" /* || 'polyline' || 'polygon' */,
  label = "",
  InputProps,
  formatDisplayValue = (geo) => {
    return geo
      ? `${JSON.stringify(geo)}`
      : "Bitte wählen Sie eine Geometrie aus";
  },
  onError,
  variant,
  map,
}) => {
  if (!map) {
    console.error("`map` must be defined!");
  }

  const isControlled = value !== undefined;
  const [geoPickerActive, setGeoPickerActive] = useState(false);
  const [drawAction, setDrawAction] = useState(null);
  const [layer, setLayer] = useState();
  const [symbolObj, setSymbol] = useState();
  useEffect(() => {
    const gl = APIHelper.createGraphicsLayer();
    APIHelper.addToMap(map, gl);
    setLayer(gl);
    return () => {
      APIHelper.removeFromMap(map, gl);
    };
  }, []);

  let val;
  let setValue = () => { };
  let setValue1 = () => { };

  [val, setValue1] = useState(isControlled ? value : null);
  if (isControlled) {
    val = value;
    setValue = (/* newvalue */) => {
      // TODO
      // onChange(newvalue);
    };
  } else {
    setValue = (newValue) => {
      setValue1(newValue);
    };
  }

  useEffect(() => {
    setSymbol(
      (symbols[type.toLocaleLowerCase()] &&
        symbols[type.toLocaleLowerCase()][symbol]) ||
      symbol
    );
  }, [symbol]);
  useEffect(() => {
    if (layer) {
      APIHelper.clearLayer(layer);
      showValue(layer, val, symbolObj);
    }
  }, [val]);

  const pickGeometry = () => {
    if (!geoPickerActive) {
      setGeoPickerActive(true);

      setDrawAction(
        APIHelper.drawGeometryWithoutTooltips(
          null,
          map,
          type,
          (success, geometry) => {
            setGeoPickerActive(false);
            setDrawAction(null);
            if (success) {
              onChange(geometry);
              setValue(geometry);
            } else {
              // eslint-disable-next-line no-unused-expressions
              onError && onError();
              // eslint-disable-next-line no-unused-expressions
              !onError &&
                console.warn("Failed to pick Geometry or draw aborted by user");
            }
          }
        )
      );
    }
  };
  switch (type) {
    case "point":
      break;
    case "polyline":
      break;
    case "polygon":
      break;
    default:
      // eslint-disable-next-line no-console
      console.error("type not supported by GeormetryPicker (", type, ")");
      return <></>;
  }
  return (
    <span
      /* onClick={() => {
        if (!disabled) {
          pickGeometry();
        }
      }} */
      style={{ cursor: disabled ? null /* 'not-allowed' */ : "pointer" }}
    >
      <TextField
        InputLabelProps={{ shrink: true }}
        fullWidth
        label={label}
        variant={variant}
        {...InputProps}
        InputProps={
          !disabled && {
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => {
                    if (!disabled) {
                      if (drawAction) {
                        drawAction.abort();
                        setDrawAction(null);
                      } else {
                        pickGeometry();
                      }
                    }
                  }}
                >
                  <GpsFixedIcon />
                </IconButton>
              </InputAdornment>
            ),
          }
        }
        // disabled
        value={
          geoPickerActive
            ? "Zeichnen Sie die Geometrie auf die Map."
            : formatDisplayValue(val)
        }
      />
    </span>
  );
};

export default GeometryPicker;
